import { useApplicationParameters } from "src/api/client-api/appParams";
import { FoodsIllustrations, HelperBox, WhiteBox } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Fragment, useState } from "react";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { Navigate } from "react-router";
import { Loading } from "src/components/utils/Loading";
import { ActionPlanUpsertModal } from "../ActionPlanUpsertModal/ActionPlanUpsertModal";
import { ActionPlanCreationDialog } from "./ActionPlanCreationDialog";

export const ActionPlanInit = () => {
    const theme = useTheme();
    const [invitationOpen, setInvitationOpen] = useState(false);
    const { isActionPlanSimplified } = useApplicationParameters();
    const { t } = useTranslation();
    const { actionPlan, urls, isOpenActionPlanForm, setOpenActionPlanForm, getElligibleStartingPosts } =
        useActionsContext();

    const elligibleStartingPosts = getElligibleStartingPosts();

    if (actionPlan !== null) {
        // What are you doing here, sneaky ;)
        return <Navigate to={urls.planning()} replace />;
    }

    const isLoading = elligibleStartingPosts === undefined;
    const cantBeCreated = elligibleStartingPosts?.length === 0;

    return (
        <WhiteBox>
            {isOpenActionPlanForm && <ActionPlanUpsertModal />}
            {invitationOpen && elligibleStartingPosts && (
                <ActionPlanCreationDialog posts={elligibleStartingPosts} onClose={() => setInvitationOpen(false)} />
            )}

            <Stack
                flexDirection={"column"}
                padding={theme.spacing(4, 8)}
                gap={theme.spacing(2)}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Fragment>
                    <FoodsIllustrations illustration={"underConstruction"} />
                    <Typography variant="body-medium">{t("actionplan.trajectory.notrajectory.info")}</Typography>
                    {isLoading ?
                        <Loading />
                    : cantBeCreated === true ?
                        <HelperBox>
                            <Typography variant={"body-bold"}>{t("actionplan.nolockedssq")}</Typography>
                        </HelperBox>
                    :   <Button
                            variant="primary"
                            onClick={() => {
                                if (isActionPlanSimplified()) setInvitationOpen(true);
                                else setOpenActionPlanForm(true);
                            }}
                        >
                            {t("actionplan.trajectory.notrajectory.button")}
                        </Button>
                    }
                </Fragment>
            </Stack>
        </WhiteBox>
    );
};
